import * as React from 'react';
import { FC } from 'react';

import { Box } from '@rbilabs/components-library/build/components/layout';

import ActionButton, { ActionButtonSizes } from 'components/action-button';
import useMediaQuery from 'hooks/use-media-query';

import { Body, Title, Wrapper } from './select-restaurant-cta.styled';
import { ISelectRestaurantCtaViewProps } from './types';

export const SelectRestaurantCtaView: FC<ISelectRestaurantCtaViewProps> = ({
  title,
  body,
  ctaButtonText,
  onClick,
}) => {
  const isDesktop = useMediaQuery('desktop');
  return (
    <Wrapper data-testid="select-restaurant-cta">
      <Title>{title}</Title>
      <Body>{body}</Body>
      <Box minHeight={'auto'} margin={isDesktop ? 'auto auto 0.85rem' : 'auto'}>
        <ActionButton size={ActionButtonSizes.SMALL} onClick={onClick}>
          {ctaButtonText}
        </ActionButton>
      </Box>
    </Wrapper>
  );
};
